module.exports = __webpack_public_path__ + "static/media/rom6.297017bc.jpg";